module.exports = "https://cdn.thelire.com/ins/resource/lh_special_sale@3x.494a2c3ab694d15ae4bea350d361989c.png";